import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const StatusSelectContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${pxToRem(10)};
`;
